/**
 * Default NULL (missing) value to use.
 */
export const NULL = undefined;
